import React from 'react'
import logo from '@assets/images/logo.png'
import { useForm, Controller } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, ErrorForm, InputForm } from '@components/index'
import { useYupValidation } from '@hooks/index'
import { resetPasswordSchema } from '@yupSchemas/index'
import { IAuthResetPassword } from '@interfaces/index'
import { AuthService, errorHandler } from '@services/index'
import { toast } from 'react-toastify'

export default function ResetPassword(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)

    const location = useLocation()
    const navigate = useNavigate()
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IAuthResetPassword>({
        resolver: useYupValidation(resetPasswordSchema),
    })

    async function sendResetPassword(values: IAuthResetPassword): Promise<void> {
        setIsLoading(true)
        try {
            const data = await AuthService.sendResetPassword({
                ...values,
                code: location.state.code,
                email: location.state.email,
            })
            toast(data.message, { type: 'success' })
            navigate('/')
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="box-reset-password">
            <div className="reset-password__backgound">
                <div className="reset-password__content">
                    <div className="reset-password__images">
                        <img src={logo} alt="Logo CNA construtora" className="reset-password__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <h4>Redefina sua senha</h4>
                    <form id="reset-password__form" onSubmit={handleSubmit(sendResetPassword)}>
                        <div className="reset-password__inputs">
                            <Controller
                                name="password"
                                defaultValue={''}
                                control={control}
                                render={({ field: { value, onChange } }) => {
                                    return <InputForm size='small' placeholder="Nova Senha" label="Nova Senha" type="password" name="password" value={value} onChange={onChange} />
                                }}
                            />
                            <ErrorForm error={errors.password?.message} />
                            <Controller
                                name="passwordConf"
                                control={control}
                                defaultValue={''}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <InputForm
                                            type="password"
                                            placeholder="Confirmação da nova Senha"
                                            label="Confirmação da nova Senha"
                                            name="passwordConf"
                                            value={value}
                                            onChange={onChange}
                                            size='small'
                                        />
                                    )
                                }}
                            />
                            <ErrorForm error={errors.passwordConf?.message} />
                        </div>
                        <div className="box-button-reset-password">
                            <Button secondary type={'button'} placeholder="Cancelar" onClick={() => navigate('/')} />
                            <Button isLoading={isLoading} type={'submit'} placeholder="Alterar Senha" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
